import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=850c090c&"
import script from "./BasePagination.vue?vue&type=script&lang=js&"
export * from "./BasePagination.vue?vue&type=script&lang=js&"
import style0 from "./BasePagination.vue?vue&type=style&index=0&id=850c090c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BasePagination.vue?vue&type=custom&index=0&blockType=base-pagination&%3AcurrentPage=currentPage&%3ApageSize=pageSize&%3Atotal=total&%40onChange=onChange&%40onShowSizeChange=onChange"
if (typeof block0 === 'function') block0(component)

export default component.exports